import { Accordion } from '@mantine/core'
import React from 'react'

import { ContactUploadStatus } from '../hooks/useContactUploadStatus'

export const ContactErrorsTable: React.FC<any> = ({
  contactErrors,
}: {
  contactErrors: ContactUploadStatus['failedUploads']
}) => {
  const printContact = (contact: ContactUploadStatus['failedUploads'][0]['person']) => {
    return `${contact.firstName} ${contact.lastName}, ${contact?.email || ''} ${contact?.mobilePhone || ''}`
  }
  return (
    <>
      <div className='pt-8'>
        <h2>Failed contact uploads ({contactErrors?.length})</h2>
      </div>
      <Accordion defaultValue='Apples'>
        {contactErrors?.map((contactError, i) => (
          <Accordion.Item
            key={i}
            value={contactError.person.firstName + contactError.person.lastName}
          >
            <Accordion.Control icon={<div>{contactError.rowIndex}</div>}>
              {printContact(contactError.person)}
            </Accordion.Control>
            <Accordion.Panel>
              <ul>
                {contactError.errors.map((error, i) => (
                  <li key={i}>
                    {error.action} {error.namespace}: {error.errorMessage}
                  </li>
                ))}
              </ul>
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </>
  )
}
